import type { IIndividualProduct } from '@/service/vpc/types/IIndividualProducts';

const enginesAndMotors = ['Engine', 'Generator', 'Outboard', 'ElectricMotor'];

export const getOnlyEnginesAndMotors = (products: IIndividualProduct[]) =>
  products.filter((product) => enginesAndMotors.includes(product.productCategory));

// export const getMatchingCoverage = <T extends TCoverageWithCodeData | ICoverageWithState | ICoverageWithChassisId>(
//   p: IIndividualProduct,
//   coverage: T[]
// ) => {
//   return coverage.filter(
//     (c) =>
//       `${c.chassisSeries}${c.chassisNumber}`.replaceAll(' ', '') ===
//       `${p.driveLineIdChassisSeries}${p.driveLineIdChassisNumber}`.replaceAll(' ', '')
//   );
// };

export const getUnique = (products: IIndividualProduct[]) =>
  products.reduce((all, product) => {
    const existingProduct = all.find((ex) => ex.productDesignation === product.productDesignation);
    if (!existingProduct) {
      all.push(product);
    }
    return all;
  }, [] as IIndividualProduct[]);

export const getDesignationsWithCount = (products: IIndividualProduct[]) => {
  return new Map(
    products.reduce(
      (all, prod) => {
        const existing = all.find((product) => product[0] === prod.productDesignation);
        if (!existing) {
          all.push([prod.productDesignation, 1]);
        } else {
          existing[1] += 1;
        }
        return all;
      },
      [] as [string, number][]
    )
  );
};

export const getAllDesignations = (products: IIndividualProduct[]) => products.map((prod) => prod.productDesignation);
